import { getAuthHeaders } from "../common/helpers";
import { resolveApiUrl } from "./apiUrl";

// Some env files give this as "/avatar-audit/api/user-experience". Resolved against the
// gateway here: posted to the SPA's own origin it gets a 200 (nginx serves index.html for
// any path) and the feedback never reaches the audit service.
const USER_EXPERIENCE_URL = resolveApiUrl(process.env.REACT_APP_USER_EXPERIENCE_URL);

export interface CreateUserExperienceRequest {
  rating: number;
  comment?: string;
}

export async function submitUserExperience(rating: number, comment?: string): Promise<void> {
  if (!USER_EXPERIENCE_URL) {
    throw new Error("Missing REACT_APP_USER_EXPERIENCE_URL");
  }

  const body: CreateUserExperienceRequest = { rating };
  const trimmed = comment?.trim();
  if (trimmed) {
    body.comment = trimmed;
  }

  const res = await fetch(USER_EXPERIENCE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error(`Failed to submit feedback: ${res.status}`);
  }
}
